import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

// Normalise FastAPI / Pydantic validation errors before they reach call-sites.
// Without this, `toast.error(err.response.data.detail)` crashes React because
// `detail` is an array of objects on 422 responses ("Objects are not valid as a
// React child"). After this interceptor, `err.response.data.detail` is always
// a friendly string regardless of which endpoint failed.
api.interceptors.response.use(
  (response) => response,
  (error) => {
    try {
      const raw = error?.response?.data?.detail;
      if (raw !== undefined && raw !== null && typeof raw !== "string") {
        error.response.data.detail = formatApiError(raw);
      }
    } catch (_) { /* belt-and-braces: never let the interceptor itself throw */ }
    return Promise.reject(error);
  },
);

// Endpoints that mutate the vault. When any of them returns 2xx we ping the
// installed JobVault Chrome extension so it can silently re-sync its cache
// in real time (via web-bridge.js). Untouched: read-only endpoints, community
// endpoints (extension doesn't cache those), auth endpoints.
const VAULT_MUTATION_PATTERNS = [
  /^\/profile(\/|$)/,
  /^\/education(\/|$)/,
  /^\/work(\/|$)/,
  /^\/references(\/|$)/,
  /^\/skills(\/|$)/,
  /^\/apprenticeships(\/|$)/,
  /^\/personal-examples(\/|$)/,
  /^\/documents(\/|$)/,
  /^\/import\/cv/,
  /^\/ai\/extract-subjects\/document/,
  /^\/vault\/personal(\/|$)/,
];

function notifyExtensionOfVaultUpdate() {
  try {
    if (typeof window === "undefined") return;
    window.postMessage(
      { __jobvault: true, type: "vault:updated", at: Date.now() },
      window.location.origin,
    );
  } catch { /* extension not installed / cross-origin — silent */ }
}

api.interceptors.response.use(
  (response) => {
    const method = (response.config?.method || "").toLowerCase();
    const url = response.config?.url || "";
    if (method !== "get" && method !== "head") {
      const bare = url.replace(/^https?:\/\/[^/]+\/api/, "");
      if (VAULT_MUTATION_PATTERNS.some((rx) => rx.test(bare))) {
        notifyExtensionOfVaultUpdate();
      }
    }
    return response;
  },
);

